import { createTheme } from '@mui/material/styles'

const primary = {
  main: '#2186f3',
  text: '#000000',
}

export const theme = createTheme({
  palette: {
    background: {
      default: '#FFFFFF',
    },
    primary,
    secondary: {
      main: '#E0F1F0',
    },
    text: {
      primary: '#fffffff',
      secondary: '#A6A8AA',
    },
    warning: {
      main: '#ce1637',
      light: '#ee6881',
      dark: '#a42e44',
    },
    error: {
      main: '#FC395C',
      light: '#FFEBEF',
      dark: '#FFD9E0',
    },
    grey: {
      300: '#D2D4D5',
      600: '#797D80',
    },
    common: {
      black: primary.text,
      white: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
    fontWeightRegular: 400,
    fontSize: 14,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1025,
      lg: 1280,
      xl: 1355,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
      },
    },
    MuiButton: {
      defaultProps: {},
      styleOverrides: {
        root: {
          flexShrink: 0,
          padding: '6px 10px',
          fontSize: '12px ',
          letterSpacing: '0.5 px',
          lineHeight: 1.5,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          p: '4px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          marginBottom: 0,
        },
      },
    },
  },
})
